const _temp0 = require("./home/home.view.less");


const _temp1 = require("./playground/definitions.view.less");

const _temp2 = require("./playground/editor.view.js");
const _temp3 = require("./playground/editor.view.less");

const _temp4 = require("./playground/rhymes.view.js");
const _temp5 = require("./playground/rhymes.view.less");

const _temp6 = require("./playground/syllables.view.less");

const _temp7 = require("./playground/synonyms.view.js");
const _temp8 = require("./playground/synonyms.view.less");


const _temp9 = require("./_shared/layout/default.view.js");
const _temp10 = require("./_shared/layout/default.view.less");



const _temp11 = require("./legal/termsOfService/termsOfService.view.less");


const _temp12 = require("./legal/privacyPolicy/privacyPolicy.view.less");



module.exports = {
  "home":   {
    "home":     {
      "less": _temp0
    }
  },
  "playground":   {
    "definitions":     {
      "less": _temp1
    },
    "editor":     {
      "js": _temp2,
      "less": _temp3
    },
    "rhymes":     {
      "js": _temp4,
      "less": _temp5
    },
    "syllables":     {
      "less": _temp6
    },
    "synonyms":     {
      "js": _temp7,
      "less": _temp8
    }
  },
  "_shared":   {
    "layout":     {
      "default":       {
        "js": _temp9,
        "less": _temp10
      }
    }
  },
  "legal":   {
    "termsOfService":     {
      "termsOfService":       {
        "less": _temp11
      }
    },
    "privacyPolicy":     {
      "privacyPolicy":       {
        "less": _temp12
      }
    }
  }
}